// /* eslint func-names: off */
// ;(function () {
//   if (window.subscriptionWidgetInitialized) {
//     /* eslint no-console: off */
//     console.log('Subscription widget already initialized')

//     return
//   }

//   window.subscriptionWidgetInitialized = true
  
//   window.handleFrequencyChange = function(event) {
//     const selectedOption = event.target.selectedOptions[0];
//     const sellingPlanId = selectedOption.value;
//     const variant = event.target.closest('[id^="subscription-variant--"]');
    
//     // Update the hidden selling plan select
//     const hiddenSelect = variant.querySelector('select[name="selling_plan"]');
//     if (hiddenSelect) {
//       hiddenSelect.value = sellingPlanId;
      
//       // Create and dispatch a change event
//       const changeEvent = new Event('change', { bubbles: true });
//       hiddenSelect.dispatchEvent(changeEvent);
//     }
//   }

//   document.addEventListener('DOMContentLoaded', () => {
//     var lastPurchaseType = ''
//     const productForms =
//       document.querySelectorAll('form[action^="/cart"]:not([id*="instal"])') ||
//       []

//     productForms.forEach(productForm => {
//       const productFormId = productForm.getAttribute('id')
//       const variantIdInput = productForm.querySelector('[name="id"]')
//       const sellingPlans =
//         productForm.querySelectorAll('[name="selling_plan"]') || []
//       const variants = productForm.querySelectorAll('[id^="subscription-variant--"]')
//       const parents = Array.from(variants).map(variant => variant.parentElement)

//       // Auto-select subscription option and first frequency
//       variants.forEach(wrapper => {
//         if (wrapper.className.indexOf('subscription-variant--active') !== -1) {
//           // Delay the auto-selection slightly to ensure DOM is ready
//           setTimeout(() => {
//             const subscriptionHeader = wrapper.querySelector('.subscription-option-header input[type="radio"]');
//             const frequencyDropdown = wrapper.querySelector('.frequency-dropdown');
            
//             if (subscriptionHeader) {
//               // Click the subscription radio button
//               subscriptionHeader.click();
              
//               // Select first option in frequency dropdown if exists
//               if (frequencyDropdown && frequencyDropdown.options.length > 0) {
//                 frequencyDropdown.selectedIndex = 0;
//                 const changeEvent = new Event('change', { bubbles: true });
//                 frequencyDropdown.dispatchEvent(changeEvent);
//               }
//             }
//           }, 100);
//         }
//       });

//       const updatePriceDisplay = (wrapper, productPrice) => {
//         console.log('updatePriceDisplay called with wrapper:', wrapper)
        
//         // Find the price container and its elements
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         console.log('Price container found:', priceContainer)
        
//         let productPriceElement = null
//         let originalPriceElement = null
//         let comparePriceElement = null
        
//         if (priceContainer) {
//           productPriceElement = priceContainer.querySelector('.subscription-price') || priceContainer.querySelector('.price')
//           originalPriceElement = priceContainer.querySelector('.regular-price')
//           comparePriceElement = priceContainer.querySelector('.compare-at-price')
//         }

//         console.log('Price elements found:', {
//           productPriceElement,
//           originalPriceElement,
//           comparePriceElement
//         })

//         const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
//         console.log('Selling plans select:', sellingPlans)
        
//         // Fix: Use selectedOptions or options[selectedIndex] instead of :checked
//         const sellingPlan = sellingPlans.selectedOptions[0] || sellingPlans.options[sellingPlans.selectedIndex]
//         console.log('Selected selling plan:', sellingPlan)

//         if (!sellingPlan) {
//           console.log('No selling plan selected, cannot update prices')
//           return
//         }

//         document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "none"})

//         const discountPercentage = sellingPlan.dataset.discount
//         const originalPrice = wrapper.dataset.price
//         const discountedPrice = sellingPlan.dataset.price
        
//         console.log('Price data:', {
//           discountPercentage,
//           originalPrice,
//           discountedPrice
//         })

//         const discountElement = wrapper.querySelector('.subscription-variant-discount')

//         // not displayed for subscription-only (e.g. 3-month packs)
//         if (discountElement) {
//           const discountPercentElement = discountElement.querySelector(
//             '.subscription-variant-discount-percentage'
//           )
//           const discountPriceElement = discountElement.querySelector(
//             '.subscription-variant-discount-price'
//           )

//           if (discountPercentage !== '0%') {
//             discountPercentElement.textContent = discountPercentage
//             discountPriceElement.textContent = discountedPrice
//             discountElement.style.display = ''
//           } else {
//             discountElement.style.display = 'none'
//           }
//         }

//         // Update the subscription widget's internal price displays
//         const subscriptionPriceElement = wrapper.querySelector('[data-widget-price-sub-price]')
//         const onetimePriceElement = wrapper.querySelector('[data-widget-price-onetime]')
//         const subCompareElement = wrapper.querySelector('[data-widget-price-sub-compare]')
        
//         console.log('Subscription widget internal price elements:', {
//           subscriptionPriceElement,
//           onetimePriceElement,
//           subCompareElement
//         })

//         if (subscriptionPriceElement) {
//           console.log('Updating subscription price element to:', discountedPrice)
//           subscriptionPriceElement.textContent = discountedPrice
//         }

//         if (onetimePriceElement) {
//           console.log('Updating onetime price element to:', originalPrice)
//           onetimePriceElement.textContent = originalPrice
//         }

//         if (subCompareElement) {
//           console.log('Updating subscription compare price to:', originalPrice)
//           subCompareElement.textContent = originalPrice
//         } 
//         // console.log("goodbye")
//         // console.log("discountedPrice",discountedPrice)
//         // const discountPriceSpan = document.querySelector('span#discount-price');
//         // const mainPriceSpan = document.querySelector('span#main-price');
//         // console.log(discountPrice);
//         // discountPriceSpan.style.display = 'block'
//         // discountPriceSpan.innerText = originalPrice
//         // mainPriceSpan.innerText

//         // ALWAYS show subscription pricing in main product area

//         // Calculate subscription price (20% discount)

//         const subscriptionDiscount = 20
//         const discountMultiplier = (100 - subscriptionDiscount) / 100
//         const originalPriceNum = parseFloat(originalPrice.replace(/[^0-9.]/g, ''))
//         const subscriptionPrice = originalPriceNum * discountMultiplier

//         // Format subscription price to match original format

//         const formattedSubscriptionPrice = new Intl.NumberFormat('en-US', {
//         style: 'currency',
//         currency: 'USD',
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//         }).format(subscriptionPrice)

//         if (productPriceElement) {
//           console.log('ALWAYS showing subscription price:', formattedSubscriptionPrice)
//           productPriceElement.textContent = formattedSubscriptionPrice
//         } else {
//           console.log('productPriceElement not found!')
//         }

//         if (originalPriceElement) {
//           console.log('ALWAYS showing original price as strikethrough:', originalPrice);
//           originalPriceElement.textContent = originalPrice;
//           originalPriceElement.style.display = ''
//           originalPriceElement.style.textDecoration = 'line-through'
//           originalPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//         } else {
//           console.log('originalPriceElement not found!')
//         }
        
//         console.log('updatePriceDisplay completed')
//       }
//       const resetPriceDisplay = wrapper => {
//         console.log('resetPriceDisplay called with wrapper:', wrapper)
        
//         // Find the price container and its elements
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         console.log('Price container found:', priceContainer)
        
//         let productPriceElement = null
//         let originalPriceElement = null
        
//         if (priceContainer) {
//           productPriceElement = priceContainer.querySelector('.subscription-price') || priceContainer.querySelector('.price')
//           originalPriceElement = priceContainer.querySelector('.regular-price')
//         }

//         // console.log("originalPriceElement",originalPriceElement)
//         // console.log("productPriceElement",productPriceElement)

//         // document.querySelector('.afterpay_wrap.main').style.display = "block";
//         document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "block"})

//         if (wrapper) {
//           const originalPrice = wrapper.dataset.price
//           const productTypes = wrapper.querySelectorAll('input[name="purchase_type"]');
//           if (productTypes.length <= 1) return;
//           // ALWAYS show subscription pricing in main product area
//           // Calculate subscription price (20% discount)
//           const subscriptionDiscount = 20
//           const discountMultiplier = (100 - subscriptionDiscount) / 100
//           const originalPriceNum = parseFloat(originalPrice.replace(/[^0-9.]/g, ''))
//           const subscriptionPrice = originalPriceNum * discountMultiplier

//           // Format subscription price to match original format
//           const formattedSubscriptionPrice = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: 'USD',
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//           }).format(subscriptionPrice)
//           console.log("ALWAYS showing subscription price in reset:", formattedSubscriptionPrice);

//           if (productPriceElement) {
//             productPriceElement.textContent = formattedSubscriptionPrice
//           }
//           if (originalPriceElement) {
//             originalPriceElement.textContent = originalPrice
//             originalPriceElement.style.display = ''
//             originalPriceElement.style.textDecoration = 'line-through'
//             originalPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//           }
//         }

//         // Note: originalPriceElement styling is handled above in the wrapper condition
//       }

//       const updateButtonPrice = (wrapper, isSubscription) => {
//         const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
//         if (!buttonPriceElement) return

//         const variantId = wrapper.dataset.variantId
//         if (!variantId) return

//         // Get the current variant price from the wrapper's data-price attribute
//         const priceText = wrapper.dataset.price || '$0.00'
//         const oneTimePrice = parseFloat(priceText.replace(/[^0-9.]/g, ''))
        
//                   let currentPrice = oneTimePrice
        
//         if (isSubscription) {
//           // Calculate subscription price with discount
//           const subscriptionDiscount = 20 // Default 20% discount
//           const discountMultiplier = (100 - subscriptionDiscount) / 100
//           const subscriptionPrice = oneTimePrice * discountMultiplier
//           currentPrice = subscriptionPrice
          
//           // Format the price
//           const formattedPrice = subscriptionPrice.toFixed(2)
//           buttonPriceElement.innerHTML = `• $${formattedPrice}`
//           // Update main price container to show subscription pricing
//           updateMainPriceContainer(subscriptionPrice, oneTimePrice, true)
//         } else {
//           // Show one-time price
//           const formattedPrice = oneTimePrice.toFixed(2)
//           buttonPriceElement.innerHTML = `• $${formattedPrice}`
          
//           // Update main price container to show one-time pricing
//           updateMainPriceContainer(oneTimePrice, oneTimePrice, false)
//         }
        
//         // Update Afterpay installments
//         updateAfterpayInstallments(currentPrice)
//       }

//       const updateAfterpayInstallments = (price) => {
//         const afterpayElement = document.getElementById('afterpay_instalments')
//         if (!afterpayElement) return

//         // Calculate installment amount (price divided by 4)
//         const installmentAmount = price / 4
        
//         // Format as currency
//         const formattedInstallment = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: 'USD',
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//         }).format(installmentAmount)

//         afterpayElement.textContent = formattedInstallment
//       }

//       const syncToStickyBar = (isSubscription) => {
//         const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
//         if (!stickyBar) return
        
//         const stickyOneTimeRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="onetime"]')
//         const stickySubscriptionRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="subscription"]')
        
//         if (isSubscription && stickySubscriptionRadio) {
//           stickySubscriptionRadio.checked = true
//           stickySubscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }))
//         } else if (!isSubscription && stickyOneTimeRadio) {
//           stickyOneTimeRadio.checked = true
//           stickyOneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }))
//         }
//       }

//       const updateMainPriceContainer = (displayPrice, originalPrice, isSubscription) => {
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         if (!priceContainer) return

//         const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
//         const regularPriceElement = priceContainer.querySelector('.regular-price')
//         const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
        
//         if (!subscriptionPriceElement || !regularPriceElement) return

//         // Format prices as currency
//         const formatPrice = (price) => {
//           return new Intl.NumberFormat('en-US', {
//             style: 'currency',
//             currency: 'USD',
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//           }).format(price)
//         }

//         // ALWAYS show subscription pricing in main product area
//         // Calculate subscription price (20% discount)
//         const subscriptionDiscount = 20
//         const discountMultiplier = (100 - subscriptionDiscount) / 100
//         const subscriptionPrice = originalPrice * discountMultiplier
//         // Always show subscription price as main price, regular price as crossed out
//         subscriptionPriceElement.textContent = formatPrice(subscriptionPrice)
        
//         // Always ensure subscription styling
//         subscriptionPriceElement.style.color = '#181818'
//         subscriptionPriceElement.style.textDecoration = 'none'
//         regularPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//         regularPriceElement.style.textDecoration = 'line-through'
//         regularPriceElement.style.display = 'block'
        
//         // Show subscription badge if it exists
//         if (subscriptionBadge) {
//           subscriptionBadge.style.display = ''
//         }

//       }

//       sellingPlans.forEach(el => el.setAttribute('form', productFormId))

//       variants.forEach(wrapper => {
//         const purchaseTypes = wrapper.querySelectorAll(
//           'input[name="purchase_type"]'
//         )
//         purchaseTypes.forEach(purchaseType => {
//           purchaseType.addEventListener('click', e => {
//             // switch toggle
//             productForm.querySelectorAll('.rc_block__type').forEach(el => {
//               // override theme js
//               el.style.display = ''
//               el.classList.remove('rc_block__type--active')
//             })

//             const purchaseType = e.target
//             const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
//             const block = purchaseType.closest('.rc_block__type')

//             // handle subscription option not output
//             block && block.classList.add('rc_block__type--active')

//             lastPurchaseType = purchaseType.value
//             const purchaseTypes = wrapper.querySelectorAll('input[name="purchase_type"]')

//             if (lastPurchaseType === 'autodeliver' && purchaseTypes.length > 1) {
//               sellingPlans.disabled = false
//               // console.log("=>updatePriceDisplay")
//               // console.log(wrapper)
//               // This is all handled in theme.js now
//               // updatePriceDisplay(wrapper)
//               updateButtonPrice(wrapper, true) // Update button to show subscription price
//               syncToStickyBar(true) // Sync to sticky bar
//             } else {
//               sellingPlans.disabled = true
//               // console.log("=>resetPriceDisplay")
//               // console.log(wrapper)
//               resetPriceDisplay(wrapper)
//               updateButtonPrice(wrapper, false) // Update button to show one-time price
//               syncToStickyBar(false)
//             }
//           })
//         })
//       })

//       // Listen for variant update events from the theme
//       const closestSection = productForm.closest('.shopify-section, dialog')
//       if (closestSection) {
//         console.log('Setting up variant update listener for:', productForm)
        
//         closestSection.addEventListener('variant:update', (event) => {
//           console.log('Variant update event received:', event.detail)
          
//           // Don't hide/show wrappers - just update prices directly
//           const newVariantPrice = event.detail.resource.price / 100
//           const formattedPrice = `$${newVariantPrice.toFixed(2)}`
          
//           console.log('New variant price:', formattedPrice)
          
//           // Update all subscription wrapper data-price attributes
//           variants.forEach(wrapper => {
//             console.log('Updating wrapper price data:', wrapper)
//             wrapper.dataset.price = formattedPrice
//           })
          
//           // Find the currently active wrapper (the one that's visible)
//           const activeWrapper = productForm.querySelector('.subscription-variant--active')
//           console.log('Active wrapper found:', activeWrapper)
          
//           if (activeWrapper) {
//             // Update selling plan data if available
//             const sellingPlansSelect = activeWrapper.querySelector('[name="selling_plan"]')
//             console.log('Selling plans select:', sellingPlansSelect)
//             console.log('Selling plan allocations:', event.detail.resource.selling_plan_allocations)
            
//             if (sellingPlansSelect && event.detail.resource.selling_plan_allocations) {
//               // Clear existing options
//               sellingPlansSelect.innerHTML = ''
              
//               // Add new selling plan options
//               event.detail.resource.selling_plan_allocations.forEach(allocation => {
//                 console.log('Processing allocation:', allocation)
                
//                 const option = document.createElement('option')
//                 option.value = allocation.selling_plan_id
//                 option.dataset.price = `$${(allocation.price / 100).toFixed(2)}`
                
//                 // Safely get discount percentage from price_adjustments
//                 let discountPercentage = '0%'
//                 if (allocation.price_adjustments && 
//                     allocation.price_adjustments.length > 0 &&
//                     allocation.price_adjustments[0]) {
//                   discountPercentage = `${allocation.price_adjustments[0].value || 0}%`
//                 }
//                 option.dataset.discount = discountPercentage
                
//                 // Use a default name since the selling plan name might not be directly available
//                 option.textContent = `Subscription Plan ${allocation.selling_plan_id}`
//                 sellingPlansSelect.appendChild(option)
//                 console.log('Added selling plan option:', allocation.selling_plan_id, 'with discount:', discountPercentage)
//               })
              
//               // Select the first option if available
//               if (sellingPlansSelect.options.length > 0) {
//                 sellingPlansSelect.selectedIndex = 0
                
//                 // Trigger change event to update hidden selling plan select
//                 const changeEvent = new Event('change', { bubbles: true });
//                 sellingPlansSelect.dispatchEvent(changeEvent);
//               }
              
//               console.log('Updated selling plan options')
//             }

//             // Check what purchase type is currently selected
//             const currentPurchaseType = activeWrapper.querySelector('input[name="purchase_type"]:checked')
//             const purchaseTypes = activeWrapper.querySelectorAll('input[name="purchase_type"]')
//             console.log('Current purchase type:', currentPurchaseType?.value)
            
//             if (currentPurchaseType && currentPurchaseType.value === 'autodeliver' && purchaseTypes.length > 1) {
//               // Update subscription pricing
//               console.log('Updating subscription pricing')
//               updatePriceDisplay(activeWrapper)
//               updateButtonPrice(activeWrapper, true)
//             } else {
//               // Update one-time pricing
//               console.log('Updating one-time pricing')
//               resetPriceDisplay(activeWrapper)
//               updateButtonPrice(activeWrapper, false)
//             }
//           } else {
//             console.log('No active subscription wrapper found - updating one-time pricing directly')
//             // No active subscription wrapper - update one-time pricing directly
//             const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
//             if (buttonPriceElement) {
//               buttonPriceElement.innerHTML = `• ${formattedPrice}`
//               updateAfterpayInstallments(newVariantPrice)
//               updateMainPriceContainer(newVariantPrice, newVariantPrice, false)
//             }
//           }
//         })
//       } else {
//         console.log('No closest section found for:', productForm)
//       }

//       variants.forEach(wrapper => {
//         if (wrapper.className.indexOf('subscription-variant--active') === -1) {
//           wrapper.remove()
//         } else if (wrapper.dataset.subscriptionOnly === 'true') {
//           const purchaseType = wrapper.querySelector(
//             'input[name="purchase_type"].rc_radio__autodeliver'
//           )
//           // console.log("purchaseType",purchaseType)
//           // trigger theme js things
//           purchaseType.click()

//           setTimeout(() => {
//             // again for good measure
//             purchaseType.click()
//           }, 500)
//         }
//       })
//     })
//   })

//   // Global function for deselectSubscription onclick handler
//   window.deselectSubscription = function(event) {
//     // This function is called when one-time purchase option is clicked
//     // The actual logic is handled by the radio button event listeners above
//     // This is just to prevent the error since it's referenced in the HTML
//   }
// })()
/* eslint func-names: off */


;(function () {
    if (window.subscriptionWidgetInitialized) {
      /* eslint no-console: off */
      console.log('Subscription widget already initialized')
  
      return
    }
  
    window.subscriptionWidgetInitialized = true
    
    window.handleFrequencyChange = function(event) {
      const selectedOption = event.target.selectedOptions[0];
      const sellingPlanId = selectedOption.value;
      const variant = event.target.closest('[id^="subscription-variant--"]');
      
      // Update the hidden selling plan select
      const hiddenSelect = variant.querySelector('select[name="selling_plan"]');
      if (hiddenSelect) {
        hiddenSelect.value = sellingPlanId;
        
        // Create and dispatch a change event
        const changeEvent = new Event('change', { bubbles: true });
        hiddenSelect.dispatchEvent(changeEvent);
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      var lastPurchaseType = ''
      const productForms =
        document.querySelectorAll('form[action^="/cart"]:not([id*="instal"])') ||
        []
  
      productForms.forEach(productForm => {
        const productFormId = productForm.getAttribute('id')
        const variantIdInput = productForm.querySelector('[name="id"]')
        const sellingPlans =
          productForm.querySelectorAll('[name="selling_plan"]') || []
        const variants = productForm.querySelectorAll('[id^="subscription-variant--"]')
        const parents = Array.from(variants).map(variant => variant.parentElement)

        // Auto-select subscription option and first frequency
        variants.forEach(wrapper => {
          if (wrapper.className.indexOf('subscription-variant--active') !== -1) {
            // Delay the auto-selection slightly to ensure DOM is ready
            setTimeout(() => {
              const subscriptionHeader = wrapper.querySelector('.subscription-option-header input[type="radio"]');
              const frequencyDropdown = wrapper.querySelector('.frequency-dropdown');
              
              if (subscriptionHeader) {
                // Click the subscription radio button
                subscriptionHeader.click();
                
                // Select first option in frequency dropdown if exists
                if (frequencyDropdown && frequencyDropdown.options.length > 0) {
                  frequencyDropdown.selectedIndex = 0;
                  const changeEvent = new Event('change', { bubbles: true });
                  frequencyDropdown.dispatchEvent(changeEvent);
                }
              }
            }, 100);
          }
        });
  
        const updatePriceDisplay = (wrapper, productPrice, freshForm) => {
          // Use fresh form reference if provided, otherwise fall back to old reference
          const formToUse = freshForm || productForm
          
          // The subscription widget has its OWN price elements inside the wrapper
          // Use widget-specific selectors, not the main product price selectors
          const productPriceElement = wrapper.querySelector('[data-widget-price-sub-price]')
          const originalPriceElement = wrapper.querySelector('[data-widget-price-sub-compare]')
          const comparePriceElement = document.querySelector('[data-compare-price-main]')
  
          const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
          if (!sellingPlans) {
            console.log('No selling plans found in wrapper - skipping price update')
            return
          }
          
          const sellingPlan = sellingPlans.querySelector('option:checked')
          if (!sellingPlan) {
            console.log('No checked selling plan found - skipping price update')
            return
          }
  
  
          document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "none"})
  
  
          const discountPercentage = sellingPlan.dataset.discount
          const originalPrice = wrapper.dataset.price
          const discountedPrice = sellingPlan.dataset.price
          
          if (!productPriceElement) {
            console.log('Product price element not found - skipping price update')
            return
          }
  
          const discountElement = wrapper.querySelector('.subscription-variant-discount')
  
          // not displayed for subscription-only (e.g. 3-month packs)
          if (discountElement) {
            const discountPercentElement = discountElement.querySelector(
              '.subscription-variant-discount-percentage'
            )
            const discountPriceElement = discountElement.querySelector(
              '.subscription-variant-discount-price'
            )
  
            if (discountPercentage !== '0%') {
              discountPercentElement.textContent = discountPercentage
              discountPriceElement.textContent = discountedPrice
              discountElement.style.display = ''
            } else {
              discountElement.style.display = 'none'
            }
          } 
          // console.log("goodbye")
          // console.log("discountedPrice",discountedPrice)
          // const discountPriceSpan = document.querySelector('span#discount-price');
          // const mainPriceSpan = document.querySelector('span#main-price');
          // console.log(discountPrice);
          // discountPriceSpan.style.display = 'block'
          // discountPriceSpan.innerText = originalPrice
          // mainPriceSpan.innerText
  
          productPriceElement.textContent = discountedPrice
  
          if (originalPriceElement) {
            if (
              discountedPrice === originalPrice ||
              (comparePriceElement && comparePriceElement.textContent.trim() !== '')
            ) {
              originalPriceElement.textContent = ''
              originalPriceElement.style.display = 'none'
            } else {
              originalPriceElement.textContent = originalPrice.split(".")[0]
              originalPriceElement.style.display = ''
            }
          }
        }
        const resetPriceDisplay = (wrapper, freshForm) => {
          // Use fresh form reference if provided, otherwise fall back to old reference
          const formToUse = freshForm || productForm
          
          // The subscription widget has its OWN one-time price element inside the wrapper
          // Use widget-specific selector for one-time purchase
          const productPriceElement = wrapper.querySelector('[data-widget-price-onetime]')
          const originalPriceElement = null // One-time doesn't have a compare price in the widget
  
          // console.log("originalPriceElement",originalPriceElement)
          // console.log("productPriceElement",productPriceElement)
  
          // document.querySelector('.afterpay_wrap.main').style.display = "block";
          document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "block"})
  
          if (wrapper) {
            const originalPrice = wrapper.dataset.price
            console.log('Resetting to original price:', originalPrice)
            
            if (productPriceElement) {
              productPriceElement.textContent = originalPrice
            }
            
            // Reset regular price element properly
            if (originalPriceElement) {
              // For one-time purchase, check if there's a compare-at price
              if (comparePriceElement && comparePriceElement.textContent && comparePriceElement.textContent.trim() !== '') {
                // There's a compare-at price, so show the regular price as struck through
                originalPriceElement.textContent = comparePriceElement.textContent
                originalPriceElement.style.removeProperty('display')
                originalPriceElement.style.display = ''
                console.log('One-time mode - showing regular price element with compare-at price')
              } else {
                // No compare-at price, hide the regular price element
                originalPriceElement.textContent = ''
                originalPriceElement.style.display = 'none'
                console.log('One-time mode - hiding regular price element - no compare-at price')
              }
              console.log('Reset originalPriceElement display style:', originalPriceElement.style.display)
            }
          }
          
          console.log('resetPriceDisplay completed')
        }

        const updateButtonPrice = (wrapper, isSubscription) => {
          const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
          // debugger;
          if (!buttonPriceElement) return

          const variantId = wrapper.dataset.variantId
          if (!variantId) return

          // Get the current variant price from the wrapper's data-price attribute
          const priceText = wrapper.dataset.price || '€0.00'

          const normalizedPrice = priceText.replace(/[^0-9.,]/g, '').replace(',', '.')
          const oneTimePrice = parseFloat(normalizedPrice)
          
          // ALWAYS calculate the subscription price (even when one-time is selected)
          // This ensures the event always contains the correct subscription price
          const productFormComponent = productForm.closest('product-form-component')
          const hasSubZero = productFormComponent?.dataset.hasSubZero === 'true'
          const hasSubSave = productFormComponent?.dataset.hasSubSave === 'true'
          const discountAttr = productFormComponent?.dataset.subscriptionDiscount

          // Check if there's a Recharge allocation price available
          const sellingPlansSelect = wrapper.querySelector('[name="selling_plan"]')
          const selectedPlan = sellingPlansSelect?.querySelector('option:checked')
          const rechargePrice = selectedPlan?.dataset.price
          
          // Helper function to parse price (handles EUR format with comma as decimal separator)
          const parsePrice = (priceText) => {
            if (!priceText) return 0
            // Handle both comma and period as decimal separators
            const normalizedPrice = priceText.replace(/[^0-9.,]/g, '').replace(',', '.')
            return parseFloat(normalizedPrice)
          }
          
          // Calculate subscription price based on product tags
          let subscriptionPrice = oneTimePrice // Default fallback
          if (hasSubZero) {
            // sub-0: No discount, always use regular price
            subscriptionPrice = oneTimePrice
          } else if (hasSubSave && rechargePrice) {
            // sub-save: Use Recharge allocation price when available
            subscriptionPrice = parsePrice(rechargePrice)
          } else if (hasSubSave && !rechargePrice) {
            // sub-save: Fallback to regular price if Recharge hasn't loaded yet
            subscriptionPrice = oneTimePrice
          } else if (rechargePrice) {
            // Standard products: Use Recharge allocation price if available
            subscriptionPrice = parsePrice(rechargePrice)
          } else {
            // Standard products: Fallback to custom discount calculation
            const subscriptionDiscount = parseFloat(discountAttr || '20')
            const discountMultiplier = (100 - subscriptionDiscount) / 100
            subscriptionPrice = oneTimePrice * discountMultiplier
          }
          
          let currentPrice = oneTimePrice
          
          if (isSubscription) {
            currentPrice = subscriptionPrice
            
            // Format the price
            const formattedPrice = subscriptionPrice.toFixed(2).replace('.', ',')
            buttonPriceElement.innerHTML = `• €${formattedPrice}`
            // Update main price container to show subscription pricing
            updateMainPriceContainer(subscriptionPrice, oneTimePrice, true)
          } else {
            // Show one-time price
            const formattedPrice = oneTimePrice.toFixed(2).replace('.', ',')
            buttonPriceElement.innerHTML = `• €${formattedPrice}`
            
            // Update main price container to show one-time pricing
            updateMainPriceContainer(oneTimePrice, oneTimePrice, false)
          }
          
          // Update Afterpay installments
          updateAfterpayInstallments(currentPrice)
          
          // Dispatch custom event for sticky cart to listen to
          // IMPORTANT: Always send the correct subscription price, not the currently displayed price
          const priceUpdateEvent = new CustomEvent('subscription:price-update', {
            bubbles: true,
            detail: {
              isSubscription: isSubscription,
              subscriptionPrice: subscriptionPrice,
              oneTimePrice: oneTimePrice,
              variantId: variantId
            }
          })
          document.dispatchEvent(priceUpdateEvent)
          // console.log('[Subscription Widget] Dispatched price update event:', { isSubscription, subscriptionPrice, oneTimePrice })
        }

        const updateAfterpayInstallments = (price) => {
          const afterpayElement = document.getElementById('afterpay_instalments')
          if (!afterpayElement) return

          // Calculate installment amount (price divided by 4)
          const installmentAmount = price / 4
          
          // Format as currency - Get currency from Shopify or default to EUR
          const currency = window.Shopify?.currency?.active || 'EUR'
          let formattedInstallment
          if (currency === 'EUR') {
            // Manual formatting for EUR: €XX,XX (comma as decimal separator)
            formattedInstallment = '€' + installmentAmount.toFixed(2).replace('.', ',')
          } else {
            // Use standard formatting for other currencies
            formattedInstallment = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currency,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(installmentAmount)
          }

          afterpayElement.textContent = formattedInstallment
        }

        const syncToStickyBar = (isSubscription) => {
          const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
          if (!stickyBar) return
          
          const stickyOneTimeRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="onetime"]')
          const stickySubscriptionRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="subscription"]')
          
          if (isSubscription && stickySubscriptionRadio) {
            stickySubscriptionRadio.checked = true
            stickySubscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }))
          } else if (!isSubscription && stickyOneTimeRadio) {
            stickyOneTimeRadio.checked = true
            stickyOneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }

        const updateMainPriceContainer = (displayPrice, originalPrice, isSubscription) => {
          const priceContainer = document.querySelector('[ref="priceContainer"]')
          if (!priceContainer) {
            // console.log('[Main Price] Price container not found')
            return
          }

          // Get product tag data to know which price elements to target
          const productFormComponent = productForm.closest('product-form-component')
          const hasSubZero = productFormComponent?.dataset.hasSubZero === 'true'
          const hasSubSave = productFormComponent?.dataset.hasSubSave === 'true'
          
          // Format prices as currency
          const formatPrice = (price) => {
            // Get currency from Shopify's cart currency or default to EUR for EU site
            const currency = window.Shopify?.currency?.active || 'EUR'
            
            if (currency === 'EUR') {
              // Manual formatting for EUR: €XX,XX (comma as decimal separator)
              return '€' + price.toFixed(2).replace('.', ',')
            } else {
              // Use standard formatting for other currencies
              return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(price)
            }
          }

          // console.log('[Main Price] Updating price:', { displayPrice, originalPrice, isSubscription, hasSubZero, hasSubSave })

          // For sub-0 and sub-save products, they use .price element, not .subscription-price
          if (hasSubZero || hasSubSave) {
            const priceElement = priceContainer.querySelector('.price')
            if (priceElement) {
              // sub-0 and sub-save always show the same price (no subscription discount display)
              priceElement.textContent = formatPrice(displayPrice)
              // console.log('[Main Price] Updated sub-0/sub-save price element')
            } else {
              // console.log('[Main Price] .price element not found for sub-0/sub-save product')
            }
            
            // Handle badge visibility for sub-save products
            if (hasSubSave) {
              const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
              if (subscriptionBadge) {
                // Check if product has both options or is subscription-only
                const oneTimeRadio = document.querySelector('input[name="purchase_type"][value=""]')
                const subscriptionRadio = document.querySelector('input[name="purchase_type"][value="autodeliver"]')
                const hasOneTimeOption = oneTimeRadio !== null
                const isSubscriptionOnly = subscriptionRadio !== null && !hasOneTimeOption
                
                if (isSubscriptionOnly) {
                  // Subscription-only product - always show badge
                  subscriptionBadge.style.display = ''
                  // console.log('[Main Price] Showing badge for sub-save subscription-only product')
                } else if (isSubscription) {
                  // Has both options and subscription is selected
                  subscriptionBadge.style.display = ''
                  // console.log('[Main Price] Showing badge for sub-save subscription')
                } else {
                  // Has both options and one-time is selected
                  subscriptionBadge.style.display = 'none'
                  // console.log('[Main Price] Hiding badge for sub-save one-time')
                }
              }
            }
            return
          }

          // For regular subscription products
          const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
          const regularPriceElement = priceContainer.querySelector('.regular-price')
          const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
          
          if (!subscriptionPriceElement) {
            // console.log('[Main Price] .subscription-price element not found')
            return
          }

          if (isSubscription) {
            // Show subscription price as main price, regular price as crossed out
            subscriptionPriceElement.textContent = formatPrice(displayPrice)
            if (regularPriceElement) {
              regularPriceElement.textContent = formatPrice(originalPrice)
              regularPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
              regularPriceElement.style.textDecoration = 'line-through'
              regularPriceElement.style.display = 'block'
            }
            
            subscriptionPriceElement.style.color = '#181818'
            subscriptionPriceElement.style.textDecoration = 'none'
            
            // Show subscription badge
            if (subscriptionBadge) {
              subscriptionBadge.style.display = ''
            }
            
            // console.log('[Main Price] Updated to subscription price')
          } else {
            // Show one-time price
            subscriptionPriceElement.textContent = formatPrice(displayPrice)
            if (regularPriceElement) {
              regularPriceElement.textContent = ''
              regularPriceElement.style.display = 'none'
            }
            
            subscriptionPriceElement.style.color = '#181818'
            subscriptionPriceElement.style.textDecoration = 'none'
            
            // Hide subscription badge
            if (subscriptionBadge) {
              subscriptionBadge.style.display = 'none'
            }
            
            // console.log('[Main Price] Updated to one-time price')
          }
        }
  
        sellingPlans.forEach(el => el.setAttribute('form', productFormId))
  
        variants.forEach(wrapper => {
          const purchaseTypes = wrapper.querySelectorAll(
            'input[name="purchase_type"]'
          )
          purchaseTypes.forEach(purchaseType => {
            purchaseType.addEventListener('click', e => {
              // switch toggle
              productForm.querySelectorAll('.rc_block__type').forEach(el => {
                // override theme js
                el.style.display = ''
                el.classList.remove('rc_block__type--active')
              })
  
              const purchaseType = e.target
              const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
              const block = purchaseType.closest('.rc_block__type')
  
              // handle subscription option not output
              block && block.classList.add('rc_block__type--active')
  
              lastPurchaseType = purchaseType.value
              const purchaseTypes = wrapper.querySelectorAll('input[name="purchase_type"]')
  
              if (lastPurchaseType === 'autodeliver' && purchaseTypes.length > 1) {
                sellingPlans.disabled = false
                console.log("=>updatePriceDisplay")
                console.log(wrapper)
                // Call updatePriceDisplay to show subscription pricing
                updatePriceDisplay(wrapper)
                updateButtonPrice(wrapper, true) // Update button to show subscription price (also dispatches event)
                syncToStickyBar(true) // Sync to sticky bar
              } else {
                sellingPlans.disabled = true
                // console.log("=>resetPriceDisplay")
                // console.log(wrapper)
                resetPriceDisplay(wrapper)
                updateButtonPrice(wrapper, false) // Update button to show one-time price (also dispatches event)
                syncToStickyBar(false)
              }
            })
        })

        // Add event listener for delivery frequency dropdown changes (e.g., every 30 days -> every 60 days)
        variants.forEach(wrapper => {
          const sellingPlansSelect = wrapper.querySelector('[name="selling_plan"]')
          if (sellingPlansSelect) {
            sellingPlansSelect.addEventListener('change', () => {
              // console.log('[Subscription Widget] Delivery frequency dropdown changed')
              
              // Check if subscription is currently selected
              const subscriptionRadio = wrapper.querySelector('input[name="purchase_type"][value="autodeliver"]:checked')
              
              if (subscriptionRadio) {
                // Update price display with new delivery frequency's price
                updatePriceDisplay(wrapper, null, productForm)
                updateButtonPrice(wrapper, true) // Also dispatches event for sticky cart
                
                // console.log('[Subscription Widget] Prices updated for new delivery frequency')
              }
            })
          }
        })
      })

        // Listen for variant update events from the theme
        const closestSection = productForm.closest('.shopify-section, dialog')
        if (closestSection) {
          console.log('Setting up variant update listener for:', productForm)
          
          closestSection.addEventListener('variant:update', (event) => {
            // Don't hide/show wrappers - just update prices directly
            const newVariantPrice = event.detail.resource.price / 100
            const formattedPrice = `€${newVariantPrice.toFixed(2)}`
            
            // Update all subscription wrapper data-price attributes
            variants.forEach(wrapper => {
              wrapper.dataset.price = formattedPrice
            })
            
            // Use a small delay to allow DOM morph to complete before updating prices
            setTimeout(() => {
              const variantId = event.detail.resource.id
              
              // Re-query the productForm fresh since it might be replaced during morph
              const freshProductForm = closestSection.querySelector('form[action^="/cart"]:not([id*="instal"])')
              
              if (!freshProductForm) {
                console.log('Product form not found after morph - cannot update prices')
                return
              }
              
              // Re-query the DOM fresh each time since DOM morphs replace content
              // The old 'variants' variable references become stale after morph
              let activeWrapper = freshProductForm.querySelector('[id^="subscription-variant--"]')
              
              // Fallback: Query all fresh and find visible one
              if (!activeWrapper) {
                const freshWrappers = freshProductForm.querySelectorAll('[id^="subscription-variant--"]')
                freshWrappers.forEach(wrapper => {
                  const computedStyle = window.getComputedStyle(wrapper)
                  if (computedStyle.display !== 'none') {
                    activeWrapper = wrapper
                  }
                })
              }
              
              // Last fallback: Find by .subscription-variant--active class
              if (!activeWrapper) {
                activeWrapper = freshProductForm.querySelector('.subscription-variant--active')
              }
              
              // Wrapper found - proceed with updates
              
              if (activeWrapper) {
                // Update selling plan data if available
                const sellingPlansSelect = activeWrapper.querySelector('[name="selling_plan"]')
                
                if (sellingPlansSelect && event.detail.resource.selling_plan_allocations) {
                  // Clear existing options
                  sellingPlansSelect.innerHTML = ''

                  // Get product tag info to apply correct pricing
                  const productFormComponent = activeWrapper.closest('product-form-component')
                  const hasSubZero = productFormComponent?.dataset.hasSubZero === 'true'

                  // Get the variant's regular price (without any discount)
                  const variantRegularPrice = event.detail.resource.price
                  
                  // Add new selling plan options
                  event.detail.resource.selling_plan_allocations.forEach(allocation => {
                    const option = document.createElement('option')
                    option.value = allocation.selling_plan_id
                    
                    // Calculate correct price based on product tags
                    let calculatedPrice

                    if (hasSubZero) {
                      // sub-0: no discount, use regular price
                      calculatedPrice = variantRegularPrice
                    } else {
                      // Use allocation price from Recharge (includes configured discount, includes sub-save)
                      calculatedPrice = allocation.price
                    }

                    option.dataset.price = `€${(calculatedPrice / 100).toFixed(2)}`
                    
                    // Safely get discount percentage from price_adjustments
                    let discountPercentage = '0%'
                    if (allocation.price_adjustments && 
                        allocation.price_adjustments.length > 0 &&
                        allocation.price_adjustments[0]) {
                      discountPercentage = `${allocation.price_adjustments[0].value || 0}%`
                    }
                    option.dataset.discount = discountPercentage
                    
                    // Use a default name since the selling plan name might not be directly available
                    option.textContent = `Subscription Plan ${allocation.selling_plan_id}`
                    sellingPlansSelect.appendChild(option)
                  })
                  
                  // Select the first option if available
                  if (sellingPlansSelect.options.length > 0) {
                    sellingPlansSelect.selectedIndex = 0
                    
                    // Trigger change event to update hidden selling plan select
                    const changeEvent = new Event('change', { bubbles: true });
                    sellingPlansSelect.dispatchEvent(changeEvent);
                  }
                }

                // Check what purchase type is currently selected
                const currentPurchaseType = activeWrapper.querySelector('input[name="purchase_type"]:checked')
                const purchaseTypes = activeWrapper.querySelectorAll('input[name="purchase_type"]')
                
                // ALWAYS update BOTH subscription AND one-time prices since both are visible
                // Update subscription prices (discounted + original)
                updatePriceDisplay(activeWrapper, null, freshProductForm)
                
                // Update one-time price
                resetPriceDisplay(activeWrapper, freshProductForm)
                
                // Update button price based on what's selected (also dispatches event)
                if (currentPurchaseType && currentPurchaseType.value === 'autodeliver' && purchaseTypes.length > 1) {
                  updateButtonPrice(activeWrapper, true)
                } else {
                  updateButtonPrice(activeWrapper, false)
                }
              } else {
                // No active subscription wrapper - update one-time pricing directly
                const buttonPriceElement = freshProductForm.querySelector('[ref="buttonPrice"]')
                if (buttonPriceElement) {
                  buttonPriceElement.innerHTML = `• ${formattedPrice}`
                  updateAfterpayInstallments(newVariantPrice)
                  updateMainPriceContainer(newVariantPrice, newVariantPrice, false)
                }
              }
            }, 150) // Wait 150ms for DOM to settle after morph
          })
        } else {
          console.log('No closest section found for:', productForm)
        }
  
        variants.forEach(wrapper => {
          if (wrapper.className.indexOf('subscription-variant--active') === -1) {
            wrapper.remove()
          } else if (wrapper.dataset.subscriptionOnly === 'true') {
            const purchaseType = wrapper.querySelector(
              'input[name="purchase_type"].rc_radio__autodeliver'
            )
            // console.log("purchaseType",purchaseType)
            // trigger theme js things
            purchaseType.click()
  
            setTimeout(() => {
              // again for good measure
              purchaseType.click()
            }, 500)
          }
        })
      })
    })
  })()
